/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable import/no-extraneous-dependencies */
import { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { Grid, GridColumn as Column } from "@progress/kendo-react-grid";
import { process } from "@progress/kendo-data-query";
import { Card, CardBody, Flex } from "@chakra-ui/react";
import { FaEdit } from "react-icons/fa";
import FilterBarV2 from "components/customers/filter-bar";
import Loader from "components/PageLoader";
import { useUser } from "../../hooks/use-user";
import { Paths } from "../../routes/paths";
import { HasPermission } from "../../utils/helper";
import { useGetCustomersListPaginated } from "../../services/customer-api";
import { initialDataState } from "./constants";

export default function CustomersFollowUp() {
  const [users, setUsers] = useState([]);
  const user = useUser();
  const [dataState, setDataState] = useState(initialDataState);
  const [totalRecords, setTotalRecords] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const pageSize = 25;
  const [filters, setFilters] = useState({
    searchCriteria: "",
    selectedDate: new Date(),
    cashCenterId: "",
  });
  const {
    mutate: getCustomersList,
    isSuccess: customerListAvailable,
    data: customersList,
    reset: resetUsersList,
    isPending: gettingList,
  } = useGetCustomersListPaginated();

  useEffect(() => {
    if (customerListAvailable) {
      setUsers(customersList.data.data);
      setTotalRecords(customersList.data.totalRecords);
      resetUsersList();
    }
  }, [customerListAvailable]);

  useEffect(() => {
    setCurrentPage(1);
    getCustomersList({
      pageNumber: 1,
      pageRowCount: pageSize,
      searchCriteria: filters.searchCriteria || "",
      operationDate: filters.selectedDate,
      cashCenterId: filters.cashCenterId || "",
    });
  }, [filters]);

  const viewCustomerCell = ({ dataItem }) => {
    return (
      <td>
        {canViewDetails ? (
          <Flex
            as={Link}
            to={`${Paths.customerDetails}/${dataItem.customerId}`}
            style={{ cursor: "pointer", color: "blue" }}
            w="100%"
            title="View Details"
          >
            {dataItem.name}
          </Flex>
        ) : (
          <Flex>{dataItem.name}</Flex>
        )}
      </td>
    );
  };

  const editCustomerCell = ({ dataItem }) => {
    return (
      <td>
        <Flex
          as={Link}
          to={`${Paths.editCustomer}/${dataItem.customerId}`}
          justifyContent="center"
          style={{ cursor: "pointer" }}
          w="100%"
          title="Edit Customer"
        >
          <FaEdit fontSize="18px" color="var(--primary-dark)" />
        </Flex>
      </td>
    );
  };

  // const deleteCustomerCell = ({ dataItem }) => {
  //   const onDelete = () => {
  //     deleteCustomer(dataItem.customerId);
  //     setReload(!reload);
  //   };
  //   return (
  //     <td>
  //       <Flex
  //         justifyContent="center"
  //         w="100%"
  //         title="Delete Customer"
  //         cursor="pointer"
  //         onClick={() => {
  //           sweetAlert({
  //             title: "Info!",
  //             text: "This Customer will be permanently deleted!",
  //             icon: "info",
  //             confirmButtonText: "Delete",
  //             confirmButtonColor: "red",
  //             iconColor: "red",
  //             onConfirm: onDelete,
  //           });
  //         }}
  //       >
  //         <MdDeleteSweep fontSize="18px" color="red" />
  //       </Flex>
  //     </td>
  //   );
  // };

  const onPageChange = (e) => {
    const _page = e.page.skip / pageSize + 1;
    setCurrentPage(_page);
    getCustomersList({
      pageNumber: _page,
      pageRowCount: pageSize,
      searchCriteria: filters.searchCriteria,
      operationDate: filters.selectedDate,
      cashCenterId: filters.cashCenterId || "",
    });
  };

  const canEdit = useMemo(() => {
    return HasPermission(user, "Customer", "Edit");
  }, [user]);

  const canViewDetails = useMemo(() => {
    return HasPermission(user, "Customer", "View");
  }, [user]);

  // const canDelete = useMemo(() => {
  //   return HasPermission(user, "Customer", "Delete");
  // }, [user]);

  return (
    <Flex className="main-container">
      {gettingList ? <Loader /> : <></>} {gettingList ? <Loader /> : <></>}
      <Card m="20px">
        <CardBody>
          <FilterBarV2
            getList={(
              filter,
              selectedDate,
              selectedCashCenter,
              selectedCustomer,
              selectedLocation,
              selectedReason
            ) => {
              setFilters({
                searchCriteria: filter,
                selectedDate,
                cashCenterId: selectedCashCenter,
                customerId: selectedCustomer,
                assetId: selectedLocation,
                reasons: selectedReason,
              });
            }}
          />
          <Grid
            data={process(users || [], dataState)}
            {...dataState}
            onDataStateChange={(e) => {
              setDataState(e.dataState);
            }}
            filterable
            sortable
            pageable
            total={totalRecords}
            pageSize={pageSize}
            skip={(currentPage - 1) * pageSize}
            onPageChange={onPageChange}
            className="customer-list-grid"
          >
            <Column field="clientId" title="Client Id" width={160} />
            <Column
              field="name"
              title="Customer Name"
              cell={viewCustomerCell}
            />
            <Column field="shortName" title="Short Name" width={150} />
            <Column field="customerCode" title="Customer Code" width={150} />
            <Column field="customerType" title="Customer Type" width={150} />
            <Column field="status" title="Status" width={120} />
            {canEdit ? (
              <Column
                field="status"
                title="Edit"
                headerClassName="text-center"
                className="text-center"
                width={80}
                cell={editCustomerCell}
              />
            ) : (
              <></>
            )}
            {/* {canDelete ? (
              <Column
                field="status"
                title="Delete"
                headerClassName="text-center"
                className="text-center"
                width={80}
                cell={deleteCustomerCell}
              />
            ) : (
              <></>
            )} */}
          </Grid>
        </CardBody>
      </Card>
    </Flex>
  );
}
